import React, { useState, useEffect } from "react";
import HeaderDashboard from "../Common/HeaderDashboard/HeaderDashboard";
import "./Dashboard.css";
const Dashboard = () => (
  <>
    <HeaderDashboard />
    
  </>
);
export default Dashboard;
